import { render, staticRenderFns } from "./riskStatistics.vue?vue&type=template&id=115e7a30&scoped=true&"
import script from "./riskStatistics.vue?vue&type=script&lang=js&"
export * from "./riskStatistics.vue?vue&type=script&lang=js&"
import style0 from "./riskStatistics.vue?vue&type=style&index=0&id=115e7a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e7a30",
  null
  
)

export default component.exports